module.exports = [{
      plugin: require('/Users/alextarkowski/Desktop/apps/libation/my-blazing-fast-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
